"use strict";var r=require("../Guard/isArray.cjs");exports.enumeration=function(e){if(!function(e){return r.isArray(e)}(e))return e;for(var n={},t=0,u=e;t<u.length;t++){var i=u[t];n[i]=i}return n};
//# sourceMappingURL=enumeration.cjs.map
